import React from 'react';

function Footer() {
  return (
    <footer className={'footer green-background'}>
      <p>&copy; 2026 Vizo Menu. All rights reserved.</p>
    </footer>
  );
}

export default Footer;